import React from "react";
import Dialog from "@material-ui/core/Dialog";
import renderButtons from "../../helpers/renderButtons";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Slide from "@material-ui/core/Slide";
import {ReactComponent as SunnysideLogo} from "./../../images/sunnyside-logo.svg";
import {ReactComponent as JaneLogo} from "./../../images/jane-logo.svg";
import {ReactComponent as HSLogo} from "./../../images/white-hs-logo.svg";
import {ReactComponent as JaneGoldLogo} from "./../../images/jane-gold.svg";
import {useHistory} from "react-router-dom";

export default function ShopPageDialog() {
  const history = useHistory();

  const handleClose = () => {
    history.push("/");
  };

  const sunnyButton = [
    {
      active: true,
      cta_link: {
        url: "https://www.sunnyside.shop/products?brands=High%20Supply&utm_source=iheartJane&utm_medium=referral&utm_campaign=heart_jane_menu_referrals&utm_content=high_supply",
        target: "_blank",
      },
      cta_text: "SHOP HIGH SUPPLY ON SUNNYSIDE™",
      button_variant: "contained",
      button_color: "primary",
    },
  ];
  const janeButton = [
    {
      active: true,
      cta_link: {
        url: "https://iheartjane.app.link/Brand-HighSupply-Homepage",
        target: "_blank",
      },
      cta_text: "SHOP HIGH SUPPLY ON JANE",
      button_variant: "contained",
      button_color: "primary",
    },
  ];

  const janeGoldButton = [
    {
      active: true,
      cta_link: {
        url: "https://www.iheartjane.com/brands/21089/high-supply?utm_source=highsupply&utm_medium=homepage&utm_campaign=jane_gold",
        target: "_blank",
      },
      cta_text: "GET 10% BACK IN ILLINOIS",
      button_variant: "contained",
      button_color: "primary",
    },
  ];

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableBackdropClick="true"
      className="shop-page-dialog"
      style={{
        backgroundColor: "#323232",
      }}
      TransitionComponent={Slide}
    >
      <div className="dialog-wrapper">
        <div className="logo-container">
          <HSLogo />
          <div className="close">
            <IconButton
              onClick={handleClose}
              className="icon-close"
              edge="end"
              aria-label="dialog close"
            >
              <CloseIcon htmlColor="#ffffff" />
            </IconButton>
          </div>
        </div>
        <div className="content">
          <p>
            High Supply is available at Sunnyside* via Sunnyside.shop and other
            dispensaries via Jane.
          </p>
        </div>
        <div className="button-container">
          <div className="shop-link shop-sunny ">
            <SunnysideLogo className="sunny-logo" />
            {renderButtons(sunnyButton)}
          </div>
          <div className="shop-link shop-jane ">
            <JaneLogo className="jane-logo" />
            {renderButtons(janeButton)}
          </div>
          <div className="shop-link shop-jane-gold">
            <JaneGoldLogo className="jane-gold-logo" />
            {renderButtons(janeGoldButton)}
          </div>
        </div>

        <div className="disclaimer-text ">
          <p>
            Sunnyside* available only in Arizona, Illinois, Massachusetts,
            Pennsylvania and Florida. By selecting “Shop High Supply on Jane” I
            am leaving High Supply’s website. I agree to be bound by the Jane
            Technologies, Inc.{" "}
            <a
              href="https://www.iheartjane.com/terms"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>{" "}
            and{" "}
            <a
              href="https://www.iheartjane.com/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>
    </Dialog>
  );
}
